// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__iCxoM","avatar":"style_avatar__Wnjbz","introduction":"style_introduction__Ogf7q","date":"style_date__2NIru","name":"style_name__WWKA8"};